import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Text } from '@fluentui/react-components';
import { VNotificationCategoryEnum, VNotificationTypeEnum } from '../../../services';
import { lightThemeColors } from '../../../common/themes';
import { BetterIconName } from '../../../components/betterIcon';
import appConfig from '../../../config.app';
import { isPastTime, strDateToBetterLocal } from '../../../common/utils';
import BetterBadge from '../../../components/betterBadge';

interface AlarmCardProps {
  tankId: string;
  tankName: string;
  notificationType: VNotificationTypeEnum;
  notificationCategory: VNotificationCategoryEnum;
  snoozeUtil?: string;
  snoozeNote?: string;
  isSnoozed?: boolean;
  onSnooze: () => void;
  onUnsnooze: () => void;
}

export const AlarmCard: React.FC<AlarmCardProps> = ({
  tankId,
  tankName,
  notificationType,
  notificationCategory,
  snoozeUtil,
  snoozeNote,
  isSnoozed,
  onSnooze,
  onUnsnooze,
}) => {
  const isSnoozeSet = snoozeUtil && !isPastTime(snoozeUtil);
  return (
    <Card
      style={{
        padding: 20,
        minWidth: 280,
        maxHeight: 400,
        marginBottom: 12,
        overflowY: 'auto',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <BetterBadge
          icon={ appConfig.eventCategories[notificationCategory]?.icon as BetterIconName }
          color={ appConfig.eventCategories[notificationCategory]?.color }
          label={notificationType}
          keepExtended={true}
        />
        {
          (isSnoozeSet && isSnoozed) && (
            <BetterBadge
              icon={ 'AlertSnooze24Regular' as BetterIconName }
              color={ lightThemeColors.snoozed }
              label={'Snoozed'}
              keepExtended={true}
            />
          )
        }
        {
          !isSnoozed && isSnoozeSet && (
            <BetterBadge
              icon={ 'AlertSnooze24Regular' as BetterIconName }
              color={ lightThemeColors.snoozed }
              label={'Waiting to snooze...'}
              keepExtended={true}
              loading={true}
            />
          )
        }
        {
          isSnoozed && !isSnoozeSet && (
            <BetterBadge
              icon={ 'AlertSnooze24Regular' as BetterIconName }
              color={ lightThemeColors.snoozed }
              label={'Waiting to unsnooze...'}
              keepExtended={true}
              loading={true}
            />
          )
        }
      </div>
      <div>
        <div style={{ display: 'flex' }}>
          <div
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Link to={`/tank-dashboard/${tankId}`}>
              <Text
                style={{ color: lightThemeColors.primary, fontWeight: '500' }}
              >
                {tankName}
              </Text>
            </Link>
          </div>
          {
            isSnoozeSet ? (
              <Button onClick={onUnsnooze}>Unsnooze</Button>
            ) : (
              <Button appearance='primary' onClick={onSnooze}>Snooze</Button>
            )
          }
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
        }}>
          {
            isSnoozeSet && <div>
              <div><Text weight="semibold">Snooze Until:</Text> {strDateToBetterLocal(snoozeUtil)}</div>
              <div><Text weight="semibold">Snooze Note:</Text> {snoozeNote}</div>
            </div>
          }
        </div>
      </div>
    </Card>
  );
};

export default AlarmCard;
